import type { TextareaHTMLAttributes } from 'react'

export type AutoTextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  value: string
}

/** Высота поля — по тексту. Сначала сброс: иначе поле не сожмётся, когда текст стёрли. */
function fit(node: HTMLTextAreaElement | null) {
  if (!node) return
  node.style.height = 'auto'
  node.style.height = `${node.scrollHeight + 2}px`
}

/**
 * Многострочное поле, которое растёт вместе с текстом: длинную инструкцию
 * видно целиком, а не через окошко в четыре строки с полосой прокрутки.
 * Нижнюю границу задаёт CSS (`min-height` у `textarea.ui-input`), верхней нет —
 * прокручивается страница, а не поле. Ссылка-функция новая на каждый рендер,
 * поэтому высота пересчитывается при каждом изменении текста.
 */
export function AutoTextarea({ value, className = '', ...rest }: AutoTextareaProps) {
  return (
    <textarea
      ref={(node) => {
        fit(node)
      }}
      className={`ui-input ui-autogrow ${className}`.trim()}
      rows={3}
      value={value}
      {...rest}
    />
  )
}
